import { ReactNode } from 'react';
import classes from './sb-button.module.css';
import CC from '../scripts/combine-classes';

type SbButtonProps = {
  children: ReactNode,
  filename?: string,
  onClick?: () => void,
  type?: "button" | "submit" | "reset" | undefined,
  year?: string,
};

const SbButton = ({
  children,
  filename,
  onClick,
  type = 'button',
  year,
}: SbButtonProps) => {
  const bgImageStyle = filename
    ? {
      backgroundImage: `url('/img/${filename}')`,
      backgroundPosition: '50% 50%',
      backgroundSize: '200%'
    }
    : {};

  return (
    <button
      className={CC(
        classes.button,
        { [classes.image]: filename },
      )}
      type={type}
      onClick={onClick}
      style={bgImageStyle}
    >
      <div className={`${year ? classes.yearBelow : ''}`}>{children}</div>
      {year && (
        <div className={classes.year}>{year}</div>
      )}
    </button>
  );
};

export default SbButton;
